"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Button_1 = __importDefault(require("../../../Button/Button"));
var DateField_1 = __importDefault(require("../../../Form/fields/DateField"));
var NumberField_1 = __importDefault(require("../../../Form/fields/NumberField"));
var TextAreaField_1 = __importDefault(require("../../../Form/fields/TextAreaField"));
var TypyPrestupkuField_1 = __importDefault(require("../../../Form/fields/TypyPrestupkuField"));
var Form_1 = __importDefault(require("../../../Form/Form"));
var Padder_1 = require("../../../Padder");
var ModalButtonsWrap_1 = __importDefault(require("../ModalButtonsWrap"));
var PopupHeader_1 = __importDefault(require("../PopupHeader"));
var validation = function (values) {
    var datumLens = ramda_1.lensPath(['prestupek', 'nabytiPravniMoci']);
    var typyLens = ramda_1.lensPath(['prestupek', 'typyPrestupku']);
    var pipe1 = ramda_1.pipe(ramda_1.when(function () { return !ramda_1.view(datumLens, values); }, ramda_1.set(datumLens, 'Nabytí právní moci je povinné')), ramda_1.when(function () { return ramda_1.view(typyLens, values).filter(function (p) { return p.id; }).length === 0; }, ramda_1.set(typyLens, 'Přestupek je povinný')))({});
    return Object.keys(pipe1).length > 0 ? __assign(__assign({}, pipe1), { dot: '' }) : pipe1;
};
var PopupChildren = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow-y: auto;\n  max-height: 430px;\n"], ["\n  overflow-y: auto;\n  max-height: 430px;\n"])));
var PrestupekValuesForm = function (_a) {
    var onSubmit = _a.onSubmit, initialValues = _a.initialValues, headerText = _a.headerText, onZrusit = _a.onZrusit;
    return (react_1.default.createElement(Form_1.default, { initialValues: initialValues || {}, validate: validation, onSubmit: onSubmit }, function (_a) {
        var isSubmitting = _a.isSubmitting;
        return (react_1.default.createElement(Padder_1.Padder, null,
            react_1.default.createElement(PopupHeader_1.default, null, headerText),
            react_1.default.createElement(PopupChildren, null,
                react_1.default.createElement(DateField_1.default, { label: "Nabyt\u00ED pr\u00E1vn\u00ED moci", name: "prestupek.nabytiPravniMoci", toolTip: "Vyberte datum kdy p\u0159estupek nabyl pr\u00E1vn\u00ED moci" }),
                react_1.default.createElement(TypyPrestupkuField_1.default, { label: "P\u0159estupky", name: "prestupek.typyPrestupku" }),
                react_1.default.createElement(NumberField_1.default, { label: "Ulo\u017Een\u00FD spr\u00E1vn\u00ED trest", name: "prestupek.spravniTrest", placeholder: "\u010C\u00E1stka v K\u010D" }),
                react_1.default.createElement(TextAreaField_1.default, { label: "Pozn\u00E1mka", name: "prestupek.poznamka", toolTip: "Vypl\u0148te pozn\u00E1mku", maxLength: 400 })),
            react_1.default.createElement(ModalButtonsWrap_1.default, null,
                react_1.default.createElement(Button_1.default, { type: "button", primary: false, loading: isSubmitting, onClick: onZrusit, name: "Zrusit" }, "Zru\u0161it"),
                react_1.default.createElement(Button_1.default, { type: "submit", primary: true, loading: isSubmitting, name: "Ulozit" }, "Ulo\u017Eit"))));
    }));
};
PrestupekValuesForm.defaultProps = {
    initialValues: undefined,
};
exports.default = PrestupekValuesForm;
var templateObject_1;
